module.exports = __webpack_public_path__ + "static/media/province25.b3016c19.png";